import { render, staticRenderFns } from "./Product-v2.vue?vue&type=template&id=16b62d0d&scoped=true&"
import script from "./Product-v2.vue?vue&type=script&lang=js&"
export * from "./Product-v2.vue?vue&type=script&lang=js&"
import style0 from "./Product-v2.vue?vue&type=style&index=0&id=16b62d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b62d0d",
  null
  
)

export default component.exports